import { render } from "./Thumbnail.vue?vue&type=template&id=7735bec8"
import script from "./Thumbnail.vue?vue&type=script&lang=js"
export * from "./Thumbnail.vue?vue&type=script&lang=js"

import "./Thumbnail.vue?vue&type=style&index=0&id=7735bec8&lang=scss"
script.render = render

export default script